import { render, staticRenderFns } from "./BodyCompositionCreation.vue?vue&type=template&id=3fdc4f9a&scoped=true"
import script from "./BodyCompositionCreation.vue?vue&type=script&lang=js"
export * from "./BodyCompositionCreation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fdc4f9a",
  null
  
)

export default component.exports